/** Jobs sahifalari lug'ati (uz). */
export default {
  title: "Vakansiyalar",
  subtitle: "{{open}} ochiq · {{filled}} to'ldirilgan · {{closed}} yopiq",
  newJob: "+ Yangi vakansiya",
  filters: {
    carrier: "Carrier",
    carrierAll: "Carrier: hammasi",
    state: "Shtat",
    stateAny: "Shtat: istalgan",
    equipment: "Texnika",
    equipmentAny: "Texnika: istalgan",
    status: "Holat",
    statusAll: "Holat: hammasi",
    searchPlaceholder: "Vakansiya yoki carrier qidirish",
    searchAria: "Vakansiyalarni qidirish",
  },
  empty: {
    filtered: "Bu filtrlarga mos vakansiya yo'q",
    none: "Ochiq vakansiyalar yo'q",
    manager: "Yollayotgan carrier uchun vakansiya yarating.",
    viewer: "Carrier vakansiyalarini menejeringiz qo'shadi.",
  },
  columns: {
    job: "Vakansiya",
    carrier: "Carrier",
    states: "Shtatlar",
    experience: "Tajriba",
    pay: "Maosh",
    homeTime: "Uyga qaytish",
    equipment: "Texnika",
    status: "Holat",
    candidates: "Nomzodlar",
  },
  candidates_one: "{{count}} ta nomzod",
  candidates_other: "{{count}} ta nomzod",
  hiredOf: "{{openings}} o'rindan {{hired}} tasi yollangan",
  pagination: "vakansiya",
  detail: {
    notFound: "Vakansiya topilmadi.",
    posted: "e'lon qilingan: {{date}}",
    carrierStatus: "carrier {{status}}",
    openings: "O'rinlar:",
    openingsTail_one: "{{count}} ta nomzod · barcha o'rinlar to'lganda yopiladi",
    openingsTail_other: "{{count}} ta nomzod · barcha o'rinlar to'lganda yopiladi",
    notOpen: "Bu vakansiya ochiq emas",
    submitDriver: "Haydovchi topshirish",
    requirements: "Talablar",
    cdl: "CDL",
    cdlClass: "{{cls}} toifa",
    experience: "Tajriba",
    hiringStates: "Yollash shtatlari",
    mvr: "MVR",
    dui: "DUI / DWI",
    drugTest: "Narkotik testi",
    endorsements: "Ruxsatnomalar",
    notSpecified: "ko'rsatilmagan",
    notRequired: "talab qilinmaydi",
    paySchedule: "Maosh va jadval",
    pay: "Maosh",
    homeTime: "Uyga qaytish",
    equipment: "Texnika",
    signOnBonus: "Kirish bonusi",
    notes: "Izohlar",
    matchingTitle: "Mos haydovchilar · keyinroq",
    matchingText: "Shtat, texnika va tajriba bo'yicha avtomatik moslashtirish (3-bosqich). Hozircha \"Haydovchi topshirish\" dan foydalaning: haydovchi talablarga mos kelmasa, ogohlantiradi.",
    contactTitle: "Carrier kontakti va topshirish",
    contactUnavailable: "Carrier ma'lumotlari mavjud emas.",
    recruiter: "Rekruter",
    phone: "Telefon",
    email: "Email",
    method: "Usul",
    replyTime: "Javob muddati",
    candidatesTitle: "Nomzodlar ({{count}})",
    noSubmissions: "Hali topshiriqlar yo'q",
    myCandidates: "Mening nomzodlarim",
    candidates: "Nomzodlar",
    status: "Holat",
    submitted: "Topshirilgan",
    carrierReply: "Carrier javobi",
    hiddenOthers_one: "boshqa recruiterlardan {{count}} ta nomzod (ismi yashirin)",
    hiddenOthers_other: "boshqa recruiterlardan {{count}} ta nomzod (ismlari yashirin)",
    noCandidates: "Hali nomzodlar yo'q. Qualified yoki Docs holatidagi haydovchini topshiring.",
    shortBackground: "Tekshiruv",
  },
  submit: {
    title: "Haydovchini vakansiyaga topshirish",
    searchPlaceholder: "Mening haydovchilarim ichidan qidirish...",
    searchAria: "Haydovchilarni qidirish",
    eligibleHint: "Mos keladiganlar: Qualified yoki Docs. Bu vakansiyaga allaqachon topshirilgan haydovchilar ko'rsatilmaydi.",
    noMatch: "Mos haydovchi topilmadi.",
    moreHint: "{{total}} tadan {{shown}} tasi ko'rsatilmoqda — qolganini topish uchun ismini yozing.",
    noEligible: "Mos haydovchi yo'q. Avval haydovchini Qualified yoki Docs holatiga o'tkazing.",
    matches: "talablarga mos",
    notePlaceholder: "Carrier uchun izoh (ixtiyoriy)",
    withWarnings: "{{name}} ogohlantirishlar bilan topshirildi",
    submitted: "{{name}} {{carrier}} ga topshirildi",
    failed: "Haydovchini topshirib bo'lmadi.",
  },
  form: {
    chooseCarrier: "Carrier'ni tanlang.",
    titleRequired: "Vakansiya nomi majburiy.",
    saved: "Vakansiya saqlandi",
    created: "Vakansiya yaratildi",
    saveFailed: "Vakansiyani saqlab bo'lmadi.",
    editTitle: "Vakansiyani tahrirlash",
    newTitle: "Yangi vakansiya",
    carrier: "Carrier",
    choose: "Tanlang…",
    jobTitle: "Vakansiya nomi",
    titlePlaceholder: "Dry van OTR, TX",
    status: "Holat",
    openings: "O'rinlar",
    minExperience: "Minimal tajriba (oy)",
    cdlClass: "CDL toifasi",
    hiringStates: "Yollash shtatlari",
    all48: "Barcha 48 shtat",
    pickStates: "Shtatlarni tanlang yoki barcha 48 tasini belgilang",
    pay: "Maosh",
    payPlaceholder: "$1,400-1,700 / hafta",
    homeTime: "Uyga qaytish",
    driverTypes: "Qanday driverlarni oladi",
    freight: "Yuk turi",
    drivingType: "Haydash turi",
    equipment: "Texnika",
    equipmentPlaceholder: "2024 dry van, avtomat",
    signOnBonus: "Kirish bonusi",
    bonusPlaceholder: "90 kundan keyin $2,000",
    posted: "E'lon sanasi",
    endorsements: "Talab qilinadigan ruxsatnomalar",
    mvr: "MVR",
    mvrPlaceholder: "3 yilda ≤ 2 ta harakat qoidabuzarligi",
    dui: "DUI / DWI",
    duiPlaceholder: "so'nggi 10 yilda yo'q",
    drugTest: "Narkotik testi",
    drugPlaceholder: "ishga kirishda, soch + siydik",
    notes: "Izohlar",
  },
};
